import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { environment } from '../../environments/environment';

export interface PacoteAdicionalImagem {
  id: number;
  url: string;
  ordem: number;
}

export interface PacoteAdicional {
  id: number;
  nome: string;
  descricao: string | null;
  itensInclusos: string | null;
  quartoId: number;
  acomodacao: string;
  valor: number;
  ativo: boolean;
  criadoEm: string;
  atualizadoEm: string;
  imagens: PacoteAdicionalImagem[];
}

export interface PacoteAdicionalRequest {
  nome: string;
  descricao: string | null;
  itensInclusos: string | null;
  quartoId: number;
  valor: number;
  ativo: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class PacoteAdicionalService {

  private readonly http = inject(HttpClient);

  private readonly apiUrl =
    `${environment.apiUrl}/admin/pacotes`;

  private readonly apiBaseUrl =
    environment.apiUrl.replace(/\/api\/?$/, '');

  listarTodos(): Observable<PacoteAdicional[]> {
    return this.http.get<PacoteAdicional[]>(
      this.apiUrl
    );
  }

  buscar(id: number): Observable<PacoteAdicional> {
    return this.http.get<PacoteAdicional>(
      `${this.apiUrl}/${id}`
    );
  }

  criar(
    dados: PacoteAdicionalRequest
  ): Observable<PacoteAdicional> {

    return this.http.post<PacoteAdicional>(
      this.apiUrl,
      dados
    );
  }

  atualizar(
    id: number,
    dados: PacoteAdicionalRequest
  ): Observable<PacoteAdicional> {

    return this.http.put<PacoteAdicional>(
      `${this.apiUrl}/${id}`,
      dados
    );
  }

  alterarStatus(
    id: number,
    ativo: boolean
  ): Observable<PacoteAdicional> {

    return this.http.patch<PacoteAdicional>(
      `${this.apiUrl}/${id}/status`,
      null,
      {
        params: {
          ativo: ativo.toString()
        }
      }
    );
  }

  excluir(id: number): Observable<void> {

    return this.http.delete<void>(
      `${this.apiUrl}/${id}`
    );
  }

  adicionarImagens(
    pacoteId: number,
    imagens: File[]
  ): Observable<PacoteAdicional> {

    const formData = new FormData();

    imagens.forEach(imagem => {
      formData.append(
        'imagens',
        imagem
      );
    });

    return this.http.post<PacoteAdicional>(
      `${this.apiUrl}/${pacoteId}/imagens`,
      formData
    );
  }

  excluirImagem(
    pacoteId: number,
    imagemId: number
  ): Observable<PacoteAdicional> {

    return this.http.delete<PacoteAdicional>(
      `${this.apiUrl}/${pacoteId}/imagens/${imagemId}`
    );
  }

  getImagemUrl(url: string): string {

    if (!url) {
      return '';
    }

    if (
      url.startsWith('http://') ||
      url.startsWith('https://')
    ) {
      return url;
    }

    return `${this.apiBaseUrl}${url}`;
  }
}
